import { FlattenedPermission } from './flattened-permission';

export abstract class PermissionMap {
  public map: Map<number, FlattenedPermission> = new Map<number, FlattenedPermission>();
}
